<template>
  <div class="container-fluid p-0">
    <!--<div class="col-12 mb-2">-->
    <!--<div class="row align-items-center text-center">-->
    <!--&lt;!&ndash;<div class="card" v-if="hasAccess">&ndash;&gt;-->
    <!--<div class="col-12 text-center">-->
    <!--<button v-b-modal.createWork class="btn iconed btn-secondary"><i-->
    <!--class="icon-bd-plus"></i><span>جدید</span></button>-->
    <!--</div>-->
    <!--&lt;!&ndash;</div>&ndash;&gt;-->
    <!--</div>-->
    <!--</div>-->


    <div v-if="isLoading">
      <Preloader/>
    </div>
    <div v-else>

      <div class="row justify-content-center mb-5">
        <h3 class=" social-title">
          <a   href="https://charkhoune.ir/" target="_blank">مشاهده سایر محصولات و خدمات</a></h3>
      </div>


      <div class="row justify-content-center mb-3">
        <h4 class=" social-title">جهت سفارش محصولات نرم افزاری با شماره 09124448601 تماس بگیرید</h4>
      </div>
      <div class="row justify-content-center mb-3">
        <h4 class=" social-title">جهت سفارش محصولات و خدمات اتوماسیون صنعتی با شماره 09126625704 تماس بگیرید</h4>
      </div>






      <table class="table table-striped">
        <thead>
        <tr>
          <!--<th scope="col" class="text-center">عملیات</th>-->
          <!--<th scope="col" class="text-center">ردیف</th>-->
          <th scope="col" class="text-center">نام دستگاه</th>
          <th scope="col" class="text-center">شناسنامه دستگاه</th>
          <th scope="col" class="text-center">فایلهای ضمیمه</th>
          <th scope="col" class="text-center">چک لیست/برنامه های دستگاه</th>
          <!--<th scope="col" class="text-center">سابقه بازدید ها</th>-->

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in devices">

          <!--<th scope="row" class="text-center">{{item.id}}</th>-->
          <td class="text-center">{{item.companyName}}</td>
          <td class="text-center">
            <i class="clickable font-large fa fa-id-card-o px-3" @click="onGetShenClicked(item)"></i>
            <i class="clickable font-large fa fa-print px-3" @click="onPrintClicked(item)"></i>
          </td>
          <td class="text-center">
            <i class="clickable font-large fa fa-file-archive-o" @click="attachClicked(item)"></i>
          </td>
          <th scope="row" class="text-center">
            <i class="clickable font-large fa fa-check-square-o" @click="onGetCheckListClicked(item)"></i>
            <i class="clickable font-large fa fa-print px-3" @click="onPrintChecklistClicked(item)"></i>
          </th>
          <!--<th scope="row" class="text-center">-->
            <!--<i class="clickable fa fa-calendar-check-o" @click="onReportClicked(item)"></i>-->
          <!--</th>-->
        </tr>
        </tbody>
      </table>

      <!--<div class="col-12" v-if="showPagination">-->
      <!--<b-pagination size="md" v-model="pageIndex" :total-rows="rows" :per-page="pageSize" align="center"-->
      <!--@input="nextPage(pageIndex)"/>-->
      <!--</div>-->

      <!--  <div class="col-12">
          <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            @input="onWorksPaginationChange"
            :per-page="pagination.pageSize"
          ></b-pagination>
        </div>-->
    </div>
    <!-------------------------------------------------------------------------------->
    <!------------ SHENASNAMEH  MODALS -------------------------------------------------------------------->
    <b-modal
      id="shenasnamehModal"
      ref="shenasnamehModal"
      size="xl"
      title="شناسنامه دستگاه"
      ok-title="ذخیره"
      cancel-title="بستن"

      @ok="saveShenas"
    >
      <div class="row mb-2">
        <h5 class="w-100 text-center">شناسنامه دستگاه
          {{selectedDevice}}</h5>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام دستگاه</span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.name">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>مدل </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.model">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>شرکت سازنده </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.builderCompany">

          </div>
        </div>

        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>سال ساخت</span>
              </div>
            </div>
            <input
              v-show=false
              readonly="readonly"
              v-model="shenasnamehModel.productionDate"
              type="text"
              class="form-control"
            >
            <date-picker
              v-show=true
              type="date"
              :auto-submit="true"
              format="YYYY-MM-DD"
              @input="setDatePicker"
              ref="datePicker"
            >
              <slot>
                <input
                  :readonly=true
                  v-model="shenasnamehModel.productionDate"
                  class="form-control date-input"
                  @click="toggleproductionDate"
                >
              </slot>
            </date-picker>
          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>گارانتی</span>
              </div>
            </div>
            <input
              v-show=false
              readonly="readonly"
              v-model="shenasnamehModel.garantyDate"
              type="text"
              class="form-control"
            >
            <date-picker
              v-show=true
              type="date"
              :auto-submit="true"
              format="YYYY-MM-DD"
              @input="setDatePicker"
              ref="datePicker"
            >
              <slot>
                <input
                  :readonly=true
                  v-model="shenasnamehModel.garantyDate"
                  class="form-control date-input"
                  @click="togglegarantyDate"
                >
              </slot>
            </date-picker>
          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>اعتبار کالیبره</span>
              </div>
            </div>
            <input
              v-show=false
              readonly="readonly"
              v-model="shenasnamehModel.calibrateDate"
              type="text"
              class="form-control"
            >
            <date-picker
              v-show=true
              type="date"
              :auto-submit="true"
              format="YYYY-MM-DD"
              @input="setDatePicker"
              ref="datePicker"
            >
              <slot>
                <input
                  :readonly=true
                  v-model="shenasnamehModel.calibrateDate"
                  class="form-control date-input"
                  @click="togglecalibrateDate"
                >
              </slot>
            </date-picker>
          </div>
        </div>


        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>سریال </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.serialCode">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>بارکد </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.barcode">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>کد فنی </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.technicalCode">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>محل استقرار</span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.position">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>ظرفیت اسمی</span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.capacity">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>توان </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.power">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>ولتاژ </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.voltage">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>جریان </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.current">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>کسنوس فی </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.cosfi">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>ابعاد </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.dimentions">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>وزن </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.weight">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>آب مصرفی </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.waterFlow">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>هوای مصرفی </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.airFlow">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>روغن مصرفی </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.oilFlow">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>موارد متفرقه </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="shenasnamehModel.other1">

          </div>
        </div>

      </div>


      <div class="row mb-2">
        <div class="input-group col-sm-12">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>توضیحات</span>
            </div>
          </div>
          <textarea class="form-control" v-model="shenasnamehModel.description"></textarea>

        </div>
      </div>

      <div class="row mb-2">
        <div class="input-group col-sm-12">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>لوازم جانبی</span>
            </div>
          </div>
          <textarea class="form-control" v-model="shenasnamehModel.accessory"></textarea>

        </div>
      </div>

      <div class="row mb-2">
        <div class="input-group col-sm-12">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>موارد ایمنی</span>
            </div>
          </div>
          <textarea class="form-control" v-model="shenasnamehModel.saiftyLog"></textarea>

        </div>
      </div>

    </b-modal>

    <!------------ ATTACH MODAL----------------------------------------------------------------------------->
    <b-modal
      id="attachModal"
      ref="attachModal"
      size="lg"
      title="فایلهای ضمیمه"
      ok-title="ذخیره"
      cancel-title="بستن"
      @ok="closeAttachModal"
    >
      <div class="row mb-2 text-center">
        <h4 v-if="attachFiles.length===0" class="w-100 text-center">هیچ فایلی ثبت نشده است</h4>
        <table v-else class="table table-striped">
          <thead>
          <tr>
            <!--<th scope="col" class="text-center">عملیات</th>-->
            <!--<th scope="col" class="text-center">ردیف</th>-->
            <th scope="col" class="text-center">نام فایل</th>
            <th scope="col" class="text-center">توضیحات</th>
            <th scope="col" class="text-center">ورژن</th>
            <th scope="col" class="text-center">عملیات</th>

          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in attachFiles">

            <!--<th scope="row" class="text-center">{{item.id}}</th>-->
            <td class="text-center">{{item.name}}</td>
            <td class="text-center">{{item.description}}</td>
            <td class="text-center">{{item.version}}</td>
            <th scope="row" class="text-center">
              <a v-if="item.address!=='' && item.address!=null"
                 :href="validateDownloadImageUrl(item.address)"
                 target="_blank"
                 download
                 style="color: inherit !important;"
              ><i class="fa fa-download px-3 clickable"
                  style="font-size: larger"
                  title="دانلود"></i></a>
              <i class="fa fa-trash-o px-3 clickable"
                 style="font-size: larger"
                 @click="onattachFileDeleteClicked(item.id)"
                 title="حذف"></i>
            </th>
          </tr>
          </tbody>
        </table>
      </div>

      <hr class="w-100"/>

      <div class="row mb-2">
        <h4 class="col-12 w-100 text-center">ثبت فایل جدید</h4>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام فایل</span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="attachFileModel.name">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>ورژن </span>
              </div>
            </div>
            <input type="number" class="form-control" v-model="attachFileModel.version">

          </div>
        </div>
        <div class="col-12  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>توضیحات </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="attachFileModel.description">

          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-lg-12 text-center" v-if="newFileClicked">
          <span>{{attachFileModel.newname}}</span>
        </div>
        <div class="col-lg-12 text-center">

          <input type="file" id="fileUpload6" class="d-none"
                 @change="oncatalog1Change($event)">
          <label for="fileUpload6" class="btn btn-info btn-round mb-3 clickable">بارگذاری فایل</label>
        </div>
      </div>
    </b-modal>

    <!------------ DeviceChecklist MODAL----------------------------------------------------------------------------->
    <b-modal
      id="deviceChecklistModal"
      ref="deviceChecklistModal"
      size="xl"
      title="چک لیستها و برنامه های بازدید دستگاه"
      ok-title="ذخیره"
      cancel-title="بستن"
      @ok="closeAttachModal"
    >
      <div class="row mb-2 text-center">
        <h4 v-if="deviceChecklists.length===0" class="w-100 text-center">هیچ چک لیستی/برنامه ای ثبت نشده است</h4>
        <table v-else class="table table-striped">
          <thead>
          <tr>
            <!--<th scope="col" class="text-center">عملیات</th>-->
            <!--<th scope="col" class="text-center">ردیف</th>-->
            <th scope="col" class="text-center">نام چک لیست</th>
            <th scope="col" class="text-center">شرح مختصر</th>
            <th scope="col" class="text-center">نوع چک لیست</th>
            <th scope="col" class="text-center">برنامه ساعتی</th>
            <th scope="col" class="text-center">برنامه روزانه</th>
            <th scope="col" class="text-center">توضیحات</th>
            <th scope="col" class="text-center">وضعیت</th>
            <th scope="col" class="text-center">عملیات</th>

          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in deviceChecklists">

            <!--<th scope="row" class="text-center">{{item.id}}</th>-->
            <td class="text-center">{{item.pmCheckList.name}}</td>
            <td class="text-center">{{item.pmCheckList.shortDescription}}</td>
            <td class="text-center">{{item.pmCheckList.enPMListTypeTitle}}</td>
            <td class="text-center">{{item.hourlyPeriod}}</td>
            <td class="text-center">{{item.dailyPeriod}}</td>
            <td class="text-center">{{item.description}}</td>
            <td class="text-center" v-if="item.actived"><i class="fa fa-toggle-on"> فعال </i></td>
            <td class="text-center" v-if="item.actived===false"><i class="fa fa-toggle-off"> غیرفعال </i></td>
            <th scope="row" class="text-center">
              <i class="px-3 clickable fa" :class="item.actived ? 'fa-toggle-off':'fa-toggle-on'"
                 style="font-size: larger"
                 @click="ondeviceChecklistActiveClicked(item)"
                 title="فعال/غیرفعال"></i>
              <i class="fa fa-pencil-square-o px-3 clickable"
                 style="font-size: larger"
                 @click="ondeviceChecklistEditClicked(item)"
                 title="ویرایش"></i>
              <!--<i class="fa fa-trash-o px-3 clickable"-->
              <!--style="font-size: larger"-->
              <!--@click="ondeviceChecklistDeleteClicked(item.id)"-->
              <!--title="حذف"></i>-->
            </th>
          </tr>
          </tbody>
        </table>
      </div>

      <hr class="w-100"/>

      <div class="row mb-2">
        <h4 class="col-12 w-100 text-center">ثبت چک لیست/برنامه جدید</h4>
        <div class="col-12 mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom  w-100">
              <div class="input-group-text">
                <span>انتخاب چک لیست</span>
              </div>
              <vs-select
                ref="selectedProductPattern"
                :isHeader="true"
                :data="checkLists"
                :header="{label:'newName'}"
                :mode="'edit'"
                @dataChanged="checkListSelect"
              ></vs-select>
            </div>
          </div>
        </div>

        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>بازدید ساعتی(4-6-12-... ساعته)</span>
              </div>
            </div>
            <input type="number" class="form-control" v-model="deviceChecklistModel.hourlyPeriod">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>ساعت شروع</span>
              </div>
            </div>
            <input type="number" class="form-control" v-model="deviceChecklistModel.startHour">

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>بازدید روزانه(1-3-15-... روزه)</span>
              </div>
            </div>
            <input type="number" class="form-control" v-model="deviceChecklistModel.dailyPeriod">

          </div>
        </div>
        <div class="col-12  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>توضیحات </span>
              </div>
            </div>
            <input type="text" class="form-control" v-model="deviceChecklistModel.description">

          </div>
        </div>
        <div class="col-12  mb-2">
          <button class="btn btn-success w-100 text-center" @click="saveDeviceChecklist">ثبت/ویرایش برنامه</button>
        </div>
      </div>

    </b-modal>

    <!------------- PRINT -------------------------------------------------------------------------->
    <div id="printShenas" class="d-none">
      <div class="row mb-2">
        <h5 class="w-100 text-center">شناسنامه دستگاه
          {{selectedDevice}}</h5>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>نام دستگاه</span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.name}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>مدل </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.model}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>شرکت سازنده </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.builderCompany}}</span>

          </div>
        </div>

        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>سال ساخت</span>
              </div>
            </div>
            <span
              :readonly=true

              class="form-control date-input"
              @click="togglegarantyDate"
            >{{shenasnamehModel.productionDate}}</span>
          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>گارانتی</span>
              </div>
            </div>


            <span
              :readonly=true

              class="form-control date-input"
              @click="togglegarantyDate"
            >{{shenasnamehModel.garantyDate}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>اعتبار کالیبره</span>
              </div>
            </div>

            <span
              :readonly=true

              class="form-control date-input"
              @click="togglecalibrateDate"
            >{{shenasnamehModel.calibrateDate}}</span>

          </div>
        </div>


        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>سریال </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.serialCode}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>بارکد </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.barcode}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>کد فنی </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.technicalCode}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>محل استقرار</span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.position}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>ظرفیت اسمی</span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.capacity}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>توان </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.power}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>ولتاژ </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.voltage}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>جریان </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.current}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>کسنوس فی </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.cosfi}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>ابعاد </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.dimentions}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>وزن </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.weight}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>آب مصرفی </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.waterFlow}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>هوای مصرفی </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.airFlow}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>روغن مصرفی </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.oilFlow}}</span>

          </div>
        </div>
        <div class="col-4  mb-2">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>موارد متفرقه </span>
              </div>
            </div>
            <span class="form-control">{{shenasnamehModel.other1}}</span>

          </div>
        </div>

      </div>


      <div class="row mb-2 p-3">
        <span>توضیحات</span>
        <p>{{shenasnamehModel.description}}</p>
        <span>لوازم جانبی</span>
        <p v-html="shenasnamehModel.accessory"></p>
        <span>موارد ایمنی</span>
        <p v-html="shenasnamehModel.saiftyLog"></p>

      </div>


    </div>

    <div id="printList" class="row mb-2 text-center d-none">
      <h5 class="w-100 text-center">برنامه بازدید دستگاه
        {{selectedDevice}}</h5>
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col" class="text-center">نام چک لیست</th>
          <th scope="col" class="text-center">شرح مختصر</th>
          <th scope="col" class="text-center">نوع چک لیست</th>
          <th scope="col" class="text-center">برنامه ساعتی</th>
          <th scope="col" class="text-center">برنامه روزانه</th>
          <th scope="col" class="text-center">توضیحات</th>
          <th scope="col" class="text-center">وضعیت</th>

        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in deviceChecklists">

          <!--<th scope="row" class="text-center">{{item.id}}</th>-->
          <td class="text-center">{{item.pmCheckList.name}}</td>
          <td class="text-center">{{item.pmCheckList.shortDescription}}</td>
          <td class="text-center">{{item.pmCheckList.enPMListTypeTitle}}</td>
          <td class="text-center">{{item.hourlyPeriod}}</td>
          <td class="text-center">{{item.dailyPeriod}}</td>
          <td class="text-center">{{item.description}}</td>
          <td class="text-center">{{item.actived?
            "فعال":
            "غیرفعال"
            }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>


  </div>
</template>

<script>

  import VsSelect from "../../_framework/VsSelect";
  import BaseService from "../../_framework/api/BaseService.js";
  import Moment from "moment-jalali";
  import Vue from "vue";
  import Products from "../Products.vue";
  import * as $ from 'jquery';
  import checkAccess from "../../checkAccess";
  import CreateWork from "../CreateWork";
  import Utils from "../../_framework/utils/Utils";
  import VueHtmlToPaper from 'vue-html-to-paper';
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Constants from "../../Constants";

  export default {
    name: "devices",
    props: {},
    components: {
      CreateWork,
      VsSelect,
      Products,
      datePicker: DatePicker,
    },
    data: function () {
      return {
        tx1Height: 0,
        isLoading: false,
        isDeviceChecklistEditing: false,
        newFileClicked: false,
        hasAccess: true,
        printItem: {},
        access: {},
        allWorks: [],
        devices: [],
        selectedcompanyId: 0,
        shenasnamehModel: {
          id: 0,
          companyId: 0,
          name: "",
          model: "",
          serialCode: "",
          barcode: "",
          technicalCode: "",
          position: "",
          builderCompany: "",
          capacity: "",
          power: "",
          voltage: "",
          current: "",
          cosfi: "",
          productionDate: "",
          garantyDate: "",
          calibrateDate: "",
          description: "",
          dimentions: "",
          weight: "",
          waterFlow: "",
          airFlow: "",
          oilFlow: "",
          accessory: "",
          saiftyLog: "",
          other1: "",
          other2: "",
        },
        attachFileModel: {
          companyId: 0,
          name: "",
          description: "",
          address: "",
          newaddress: "",
          extention: "",
          version: 0,
        },
        dateClicked: 0,
        attachFiles: [],
        checkLists: [],
        enPMListTypes: [],
        deviceChecklists: [],
        deviceChecklistModel: {
          id: 0,
          pmCheckListId: 0,
          companyId: 0,
          hourlyPeriod: 0,
          startHour: 6,
          dailyPeriod: 0,
          description: "",
          actived: true
        },
        selectedDevice: "",
        activedView: true,
      }
    },
    mounted() {
      const printoptions = {
        name: '_blank',
        specs: [
          'fullscreen=yes',
          'titlebar=yes',
          'scrollbars=yes',

        ],
        styles: [
          './css/bootstrap4.min.css',
          './css/kidlat.css',
          './css/print-style.css',

        ],
        timeout: 10,
        autoClose: false,
        windowTitle: "شرکت آبان توسعه / پرینت رسید انبار"

      };
      Vue.use(VueHtmlToPaper, printoptions);
      this.getDevices();

      this.getType();
    },
    methods: {
      getList() {
        new BaseService('PManagment', '/GetPMCheckList').getList().then((response) => {
          this.checkLists = response.data;
          for (let i of this.checkLists) {
            for (let e of this.enPMListTypes) {
              if (e.value === i.enPMListType) {
                i.enPMListTypeTitle = e.title;
                i.newName = i.name + " / " + i.enPMListTypeTitle + " / " + i.shortDescription;
              }
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      getType() {
        new BaseService('PManagment', '/GetEnPMListType').getList().then((response) => {
          this.enPMListTypes = response.data;
          this.getList();
          // console.log(response.data)
        }).catch((error) => {
          console.log(error)
        });
      },

      onPrintClicked(item) {
        this.selectedDevice = item.companyName;
        new BaseService('PManagment', `/GetDeviceShenasnameh/${item.id}`).getList().then((response) => {
          if (response.data === null || response.data === "") {
            this.$noty.error("آیتمی برای پرینت وجود ندارد");
          } else {
            this.shenasnamehModel = response.data;
            // this.onloading();
            this.$htmlToPaper('printShenas');
          }
        }).catch((error) => {
          console.log(error)
        });

      },
      onPrintChecklistClicked(item) {
        this.selectedDevice = item.companyName;
        new BaseService('PManagment', `/GetDevicePMPlanning/${item.id}`).getList().then((response) => {
          if (response.data === [] || response.data.length === 0) {
            this.$noty.error("آیتمی برای پرینت وجود ندارد");
          } else {
            this.deviceChecklists = response.data;
            for (let i of this.deviceChecklists) {
              for (let e of this.enPMListTypes) {
                if (e.value === i.pmCheckList.enPMListType) {
                  i.pmCheckList.enPMListTypeTitle = e.title;
                }
              }
            }
            this.$htmlToPaper('printList');
          }
        }).catch((error) => {
          console.log(error)
        });

      },
      getDevices() {
        new BaseService('PManagment', '/GetDevices').getList().then((response) => {
          this.devices = response.data;
          // console.log(response.data)
        }).catch((error) => {
          console.log(error)
        });
      },
      onGetShenClicked(item) {
        new BaseService('PManagment', `/GetDeviceShenasnameh/${item.id}`).getList().then((response) => {
          if (response.data === null || response.data === "") {
          } else {
            this.shenasnamehModel = response.data;
          }
          this.shenasnamehModel.companyId = item.id;
          this.$refs['shenasnamehModal'].show();

          console.log(response.data)
        }).catch((error) => {
          console.log(error)
        });
      },
      getAttachFiles() {
        new BaseService('PManagment', `/GetCompanyAttachFile/${this.selectedcompanyId}`).getList().then((response) => {

          this.attachFiles = response.data;

          this.attachFileModel.companyId = item.id;
          console.log(response.data)
        }).catch((error) => {
          console.log(error)
        });
      },
      attachClicked(item) {
        this.selectedcompanyId = item.id;
        this.selectedDevice = item.companyName;
        this.attachFileModel.companyId = item.id;
        this.getAttachFiles();
        this.$refs['attachModal'].show();
      },
      validateDownloadImageUrl(img) {
        if (img !== undefined) {
          return Constants.DOWNLOAD_BASE_URL + img;
        }
      },
      oncatalog1Change(e) {
        let files = e.target.files;
        let app = this;
        if (files && files[0]) {
          this.newFileClicked = true;
          for (let item of files) {
            let extension = item.name.slice((item.name.lastIndexOf(".") - 1 >>> 0) + 2);
            // if (extension === "jpg" || extension === "JPG" ||
            //     extension === "png" || extension === "PNG" ||
            //     extension === "JPEG" || extension === "jpeg") {
            let reader = new FileReader();
            reader.onload = function (e) {
              // $("#bannerImg").attr("src", e.target.result);
              let a = e.target.result;

              app.attachFileModel.address = a.substring(a.indexOf(',') + 1, a.length);
              app.attachFileModel.newaddress = e.target.result;
              app.attachFileModel.newname = item.name;
              app.attachFileModel.extention = extension;
              app.shenasnamehModel.attachFileModel = app.attachFileModel;
              app.createAttachFile();
            };
            reader.readAsDataURL(item);
            // } else {
            //     alert("لطفا فایل عکس بارگذاری فرمائید");
            // }
          }
        }
      },
      createAttachFile() {
        new BaseService('PManagment', '/CreateAttachFile').create(this.attachFileModel).then((response) => {
          this.attachFileModel.name = "";
          this.attachFileModel.address = "";
          this.attachFileModel.newaddress = "";
          this.attachFileModel.description = "";
          this.attachFileModel.extention = "";
          this.attachFileModel.version = "";
          this.attachFileModel.newname = "";
          this.getAttachFiles();
          this.$noty.success("فایل با موفقیت ثبت شد");
        }).catch((error) => {
          console.log(error)
          this.$noty.error("متاسفانه خطایی رخ داده است", error);
        });
      },
      saveShenas() {
        new BaseService('PManagment', '/UpdateDeviceShenasnameh').update(this.shenasnamehModel).then((response) => {
          this.$noty.success("با موفقیت ثبت شد");

        }).catch((error) => {
          this.$noty.error("متاسفانه خطایی رخ داده", error);
          console.log(error)
        });
      },
      onGetCheckListClicked(item) {
        this.selectedcompanyId = item.id;
        this.selectedDevice = item.companyName;
        this.deviceChecklistModel.companyId = item.id;
        this.activedView = true;
        this.getDeviceChecklist();
        this.$refs['deviceChecklistModal'].show();
      },
      getDeviceChecklist() {
        new BaseService('PManagment', `/GetDevicePMPlanning/${this.selectedcompanyId}`).getList().then((response) => {
          this.deviceChecklists = response.data;
          for (let i of this.deviceChecklists) {
            for (let e of this.enPMListTypes) {
              if (e.value === i.pmCheckList.enPMListType) {
                i.pmCheckList.enPMListTypeTitle = e.title;
              }
            }
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      onReportClicked() {
      },

      closeAttachModal() {

      },
      toggleproductionDate() {
        this.dateClicked = 1;
        this.$refs.datePicker.togglePicker();
      },
      togglegarantyDate() {
        this.dateClicked = 2;
        this.$refs.datePicker.togglePicker();
      },
      togglecalibrateDate() {
        this.dateClicked = 3;
        this.$refs.datePicker.togglePicker();
      },
      setDatePicker(date) {
        console.log(date)
        if (this.dateClicked === 1) {
          this.shenasnamehModel.productionDate = date;
        }
        if (this.dateClicked === 2) {
          this.shenasnamehModel.garantyDate = date;
        }
        if (this.dateClicked === 3) {
          this.shenasnamehModel.calibrateDate = date;
        }

        // this.voucherModel.voucherDate = date;
      },
      onattachFileDeleteClicked(id) {
        if (confirm("آیا از حذف این فایل مطمئن هستید")) {
          new BaseService('PManagment/DeleteAttachFile').delete(id).then((response) => {
            this.getAttachFiles();
          }).catch((error) => {
            console.log(error)
            this.$noty.error("متاسفانه خطایی رخ داده است", error);
          });
        }
      },
      ondeviceChecklistActiveClicked(item) {
        if (item.actived) {
          if (confirm("آیا میخواهید این برنامه را غیر فعال کنید؟ ")) {
            item.actived = false;
            new BaseService('PManagment', '/UpdateDevicePMPlanning').update(item).then((response) => {

              this.getDeviceChecklist();
              this.$noty.success("برنامه با موفقیت ویرایش شد");
            }).catch((error) => {
              console.log(error);
              this.$noty.error("متاسفانه خطایی رخ داده است", error);
            });
          }
        } else {
          if (confirm("آیا میخواهید این برنامه را مجددا فعال کنید؟ ")) {
            item.actived = true;
            new BaseService('PManagment', '/UpdateDevicePMPlanning').update(item).then((response) => {

              this.getDeviceChecklist();
              this.$noty.success("برنامه با موفقیت ویرایش شد");
            }).catch((error) => {
              console.log(error);
              this.$noty.error("متاسفانه خطایی رخ داده است", error);
            });
          }
        }
      },
      ondeviceChecklistEditClicked(item) {
        this.isDeviceChecklistEditing = true;
        this.deviceChecklistModel = item;
      },
      // ondeviceChecklistDeleteClicked(id) {
      //   if (confirm("آیا از حذف این چک لیست از برنامه بازدید دستگاه مطمئن هستید")) {
      //     new BaseService('PManagment/DeleteAttachFile').delete(id).then((response) => {
      //       this.getAttachFiles();
      //     }).catch((error) => {
      //       console.log(error)
      //       this.$noty.error("متاسفانه خطایی رخ داده است", error);
      //     });
      //   }
      // },
      saveDeviceChecklist() {
        if (this.deviceChecklistModel.pmCheckListId === 0) {
          this.$noty.error("لطفا یک چک لیست انتخاب کنید");
        } else if (this.deviceChecklistModel.dailyPeriod === 0 && this.deviceChecklistModel.hourlyPeriod === 0) {
          this.$noty.error("لطفا زمان انجام بازدید را وارد کنید(روزانه یا ساعتی)");
        } else {
          let f = false;
          for (let i of this.deviceChecklists) {
            if (i.pmCheckListId === this.deviceChecklistModel.pmCheckListId) {
              f = true;
            }
          }
          if (f && !this.isDeviceChecklistEditing) {
            this.$noty.error("این چک لیست  قبلا برنامه ریزی شده است");
          } else {
            if (this.isDeviceChecklistEditing) {
              new BaseService('PManagment', '/UpdateDevicePMPlanning').update(this.deviceChecklistModel).then((response) => {
                this.deviceChecklistModel.hourlyPeriod = 0;
                this.deviceChecklistModel.startHour = 6;
                this.deviceChecklistModel.dailyPeriod = 0;
                this.deviceChecklistModel.pmCheckListId = 0;
                this.deviceChecklistModel.actived = true;
                this.deviceChecklistModel.id = 0;
                this.deviceChecklistModel.description = "";
                this.activedView = true;
                this.getDeviceChecklist();
                this.$noty.success("برنامه با موفقیت ویرایش شد");
              }).catch((error) => {
                console.log(error);
                this.$noty.error("متاسفانه خطایی رخ داده است", error);
              });
            } else {
              new BaseService('PManagment', '/CreateDevicePMPlanning').create(this.deviceChecklistModel).then((response) => {
                this.deviceChecklistModel.hourlyPeriod = 0;
                this.deviceChecklistModel.startHour = 6;
                this.deviceChecklistModel.dailyPeriod = 0;
                this.deviceChecklistModel.pmCheckListId = 0;
                this.deviceChecklistModel.actived = true;
                this.deviceChecklistModel.id = 0;
                this.deviceChecklistModel.description = "";
                this.activedView = true;
                this.getDeviceChecklist();
                this.$noty.success("برنامه با موفقیت ثبت شد");
              }).catch((error) => {
                console.log(error);
                this.$noty.error("متاسفانه خطایی رخ داده است", error);
              });
            }

          }
        }
      },
      checkListSelect(prop, data) {
        this.isDeviceChecklistEditing = false;
        this.deviceChecklistModel.pmCheckListId = data.id;
      },
    },

    computed: {
      myStylestx1() {
        return {
          height: `${this.tx1Height}px`,
          position: 'relative'
        }
      }
    }
  };

</script>

<style scoped>
  .table th, .table td {
    padding: 0.5rem !important;
  }
</style>
